import { render, staticRenderFns } from "./ItemInfo.vue?vue&type=template&id=12cde55e&scoped=true"
import script from "./ItemInfo.vue?vue&type=script&lang=js"
export * from "./ItemInfo.vue?vue&type=script&lang=js"
import style0 from "./ItemInfo.vue?vue&type=style&index=0&id=12cde55e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cde55e",
  null
  
)

export default component.exports